// The one place messages turn into bytes. Game code never touches the wire format.
// JSON now for easy debugging; a binary codec slots in here later without changing anything else.
import type { AnyMsg } from './protocol.js';

export type WireData = string | Uint8Array;

export interface Codec {
  readonly name: string;
  encode(msg: AnyMsg): WireData;
  decode(data: WireData): AnyMsg;
}

const td = new TextDecoder();

export const JsonCodec: Codec = {
  name: 'json',
  encode: msg => JSON.stringify(msg),
  decode: data => JSON.parse(typeof data === 'string' ? data : td.decode(data)),
};

export const byteLength = (d: WireData): number => typeof d === 'string' ? Buffer_byteLength(d) : d.byteLength;
// UTF-8 length without depending on Node's Buffer (works in browsers too)
function Buffer_byteLength(s: string): number {
  let n = 0;
  for (let i = 0; i < s.length; i++) { const c = s.charCodeAt(i); n += c < 0x80 ? 1 : c < 0x800 ? 2 : (c >= 0xd800 && c <= 0xdbff) ? (i++, 4) : 3; }
  return n;
}
